import PricingView from './Pricing.view';
export * from './Pricing.view';

export const Pricing = (props) => PricingView(props);

export default Pricing;

